import React from 'react';
import PropTypes from 'prop-types';
import Lightbox from 'yet-another-react-lightbox';
// import 'yet-another-react-lightbox/styles.css';
import Container from '../PageBuilder/lib/Container';
import Img from '../PageBuilder/lib/Image';
import ConditionalElement from '../PageBuilder/helpers/ConditionalElement';
import imgSrcHelper from '../PageBuilder/helpers/imgSrcHelper';

class ImageWidget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      lightboxIsOpen: false,
    };
  }

  handleOpenLightBox(e) {
    e.preventDefault();
    this.setState({ lightboxIsOpen: true });
  }

  handleCloseLightbox() {
    this.setState({ lightboxIsOpen: false });
  }

  render() {
    const {
      image,
      description,
      credits,
      variant,
      descriptionPosition,
      containerSettings,
    } = this.props;

    return (
      <Container className="container" settings={containerSettings}>
        <div className="image-widget">
          <ConditionalElement
            tagName="div"
            condition={variant === 'shifted'}
            attributes={{ className: 'shift-two-cols' }}
            childrenElements={
              <div>
                <a href="#" className="image-wrapper" onClick={(e) => this.handleOpenLightBox(e)}>
                  <Img src={image} variant="native_image" />

                  {credits === '' ? '' : <span className="credits">{ credits }</span>}

                  <span className="icon-container">
                    <span className="icon-search" />
                  </span>
                </a>

                {description === '' ? '' : <p className={`description ${descriptionPosition === 'description_right' ? '' : 'description-bottom'}`}>{description}</p>}

                <Lightbox
                  open={this.state.lightboxIsOpen}
                  close={() => this.handleCloseLightbox()}
                  slides={[{ src: imgSrcHelper(image, 'native_image') }]}
                />
              </div>
            }
          />
        </div>
      </Container>
    );
  }
}

ImageWidget.title = 'Image';
ImageWidget.preview = 'image.png';
ImageWidget.category = 'Content';

ImageWidget.propTypes = {
  image: PropTypes.any.isRequired,
  description: PropTypes.string.isRequired,
  credits: PropTypes.string.isRequired,
  variant: PropTypes.string.isRequired,
  descriptionPosition: PropTypes.string.isRequired,
  containerSettings: PropTypes.object.isRequired,
};

ImageWidget.defaults = {
  image: 'http://placehold.it/770x500',
  description: 'Image description',
  credits: '© credits',
  descriptionPosition: 'description_right',
  variant: 'shifted',
  containerSettings: {},
};

ImageWidget.adminFields = {
  image: { type: 'image' },
  description: { type: 'text' },
  credits: { type: 'text' },
  descriptionPosition: { type: 'select', options: [['description_right', 'Description right'], ['description_bottom', 'Description bottom']] },
  variant: { type: 'select', options: [['contained', 'Contained'], ['shifted', 'Shifted']] },
};

export default ImageWidget;
